module.exports = ".table-borderless{\r\n    border: 1px white;\r\n    margin-top: -12px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/acchead-grid/acchead-grid.component.css
// module id = ./src/app/finance/acchead-grid/acchead-grid.component.css
// module chunks = main